import { gql } from '@apollo/client';
import ORDER_FRAGMENT from 'graph/fragments/order';

const GET_UNAUTHENTICATED_ORDER = gql`
  query getOrderUnauthenticated($orderId: Int!, $ownerEmail: String!) {
    order(where: { id: $orderId, ownerEmail: $ownerEmail }) {
      ...OrderFragment
    }
  }
  ${ORDER_FRAGMENT}
`;

export default GET_UNAUTHENTICATED_ORDER;
